import Collapse from './Collapse';
import LeafNode from './LeafNode';
export var defaultProps = {
    renderExpand: Collapse,
    renderLeaf: LeafNode,
    data: [],
    disabled: false,
    multiple: false,
    defaultExpandAll: true,
    hasCheck: false,
    draggable: false,
    onExpand: function (expandedKeys, nodes, e) { },
    onSelect: function (selectedKeys, nodes, e) { },
    onDrop: function (snode, tnode, e) { },
    onCheck: function (checked, checkNodes, halfNodes, e) { },
};
